/**
 * Returns a Tailwind shadow class for the boundary edge of a pinned column region.
 *
 * Only the **last** left-pinned column and the **first** right-pinned column receive
 * a shadow, creating a visual boundary between the pinned region and scrollable content.
 *
 * @param pinned - The column's pinned state ('LEFT' | 'RIGHT' | null | undefined)
 * @param isEdge - Whether this column sits at the boundary of its pinned group
 */
export function getPinnedEdgeShadowClass(pinned: 'LEFT' | 'RIGHT' | null | undefined, isEdge: boolean): string {
  if (!isEdge || !pinned) {
    return '';
  }
  if (pinned === 'LEFT') {
    // Shadow on the right edge of the last left-pinned column
    return 'shadow-[2px_0_4px_-2px_rgba(0,0,0,0.15)]';
  }

  // Shadow on the left edge of the first right-pinned column
  return 'shadow-[-2px_0_4px_-2px_rgba(0,0,0,0.15)]';
}